export enum GoogleScopes {
	CONTACTS = 'https://www.googleapis.com/auth/contacts.readonly',
	DRIVE = 'https://www.googleapis.com/auth/drive',
	DIRECTORY = 'https://www.googleapis.com/auth/directory.readonly',
	ACTIVITY = 'https://www.googleapis.com/auth/drive.activity.readonly',
	DRIVE_FILE = 'https://www.googleapis.com/auth/drive.file',
}
